import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/api';

export const fetchClientDetails = createAsyncThunk<any, string>(
  'memberManager/fetchClientDetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.clientaddition.getClientDetails(id);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchClientConfig = createAsyncThunk<any, string>(
  'memberManager/fetchClientConfig',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.clientaddition.getClientSettingConfig({
        organisation_id: id
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  clientDetails: {},
  clientConfig: {}
};

const memberManager = createSlice({
  name: 'memberManager',
  initialState,
  reducers: {
    setClientDetails: (state, action) => {
      state.clientDetails = action.payload;
    },
    resetClientDetails: (state) => {
      state.clientDetails = {};
      state.clientConfig = {};
    },
    setClientConfig: (state, action) => {
      state.clientConfig = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientDetails.fulfilled, (state, action) => {
      state.clientDetails = action.payload;
    });
    builder.addCase(fetchClientDetails.rejected, (state) => {
      state.clientDetails = {};
    });
    builder.addCase(fetchClientConfig.fulfilled, (state, action) => {
      state.clientConfig = action.payload;
    });
    builder.addCase(fetchClientConfig.rejected, (state) => {
      state.clientConfig = {};
    });
  },
});

export const memberManagerActions = memberManager.actions;

export default memberManager.reducer;
